// Runtime environment detection for QuantrolixAI.
//
// The same web bundle is shipped to the browser AND to Apple App Store builds
// (Mac App Store via Electron, iOS via the WKWebView wrapper or Capacitor).
// Apple Guideline 3.1.1 forbids selling digital subscriptions outside Apple's
// IAP, so the Apple builds must ship fully functional & free: no paywall, no
// upgrade CTAs, no external Stripe checkout. Browser users keep the Stripe
// subscription flow unchanged.

const isElectron = typeof window !== 'undefined' &&
  (window.location.protocol === 'file:' ||
    (typeof navigator !== 'undefined' && navigator.userAgent.includes('Electron')));

const isCapacitor = typeof window !== 'undefined' &&
  !!window.Capacitor?.isNativePlatform?.();

// The iOS App Store build is a native WKWebView wrapper that loads the live web
// app over https; it tags its User-Agent with "QuantrolixNative" so the same web
// bundle can detect it (it is NOT electron/capacitor and uses the normal origin).
const isIosWrapper = typeof navigator !== 'undefined' &&
  /QuantrolixNative/i.test(navigator.userAgent || '');

// Web mode talks to the backend on its normal origin; Electron/Capacitor load
// from file:// and need the full host. (API_BASE logic is intentionally
// unchanged from prior behavior — only env detection is added here.)
const API_BASE = import.meta.env.VITE_API_BASE_URL ||
  ((isElectron || isCapacitor) ? 'https://apps.quantrolix.ai' : '');

// True in any Apple App Store build. Used to gate every purchase surface.
const isNativeApp = isElectron || isCapacitor || isIosWrapper;

export { API_BASE, isElectron, isCapacitor, isIosWrapper, isNativeApp };
